import type { ButtonHTMLAttributes, ElementType } from 'react';
import { cn } from '@/utils/cn';

type IconButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  label: string;
  icon: ElementType;
};

export function IconButton({ label, icon: Icon, className, ...props }: IconButtonProps) {
  return (
    <button
      type="button"
      className={cn(
        'grid size-10 place-items-center rounded bg-white/5 text-white transition hover:bg-white/10 focus:outline-none focus:ring-2 focus:ring-divergent-yellow',
        className
      )}
      aria-label={label}
      title={label}
      {...props}
    >
      <Icon size={20} aria-hidden="true" />
    </button>
  );
}
